import { render, staticRenderFns } from "./ViewSolution.vue?vue&type=template&id=1cca1aa6&scoped=true&"
import script from "./ViewSolution.vue?vue&type=script&lang=js&"
export * from "./ViewSolution.vue?vue&type=script&lang=js&"
import style0 from "./ViewSolution.vue?vue&type=style&index=0&id=1cca1aa6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca1aa6",
  null
  
)

export default component.exports